import { observer } from '@formily/reactive-vue';
import { h, useField, connect, mapProps, mapReadPretty } from '@formily/vue';
import { defineComponent, ref } from 'vue-demi';
// @ts-ignore
import Scanner from './Scanner.vue';
import { PreviewText } from '@formily/element';
import store from '@/store';

function debounce(func1, func2) {
  let timer;  // 定时器

  return function (val) {
    const context = this;  // 记录 this 值,防止在回调函数中丢失

    // 如果定时器存在，则清除定时器(如果没有,也没必要进行处理)
    timer ? clearTimeout(timer) : null;
    func1.call(context, val);
    timer = setTimeout(() => {
      // 防止 this 值变为 window
      func2.apply(context);
    }, 400);
  };
}

const formilyScanner = observer(defineComponent({
  name: 'Scanner',
  props: ['value'],
  setup(curProps, { attrs, emit }) {
    const field = useField();
    const timeStamp = ref(0);
    const resList = ref([]);
    const changeVal = debounce(
      (val) => {
        val && resList.value.push(val);
      },
      () => {
        emit('enter', resList.value);
        emit('change', resList.value);
        resList.value = [];
      },
    );
    const props = {
      ...attrs,
      ...curProps,
    };
    console.log(props, 'props');
    console.log(field, 'field');
    return () => {
      // 控制OCR按钮展示，逻辑与Picker完全一致
      let _enableImageUpload = false;
      let _photoAlbumDisabled = field.value.componentProps.photoAlbumDisabled;
      try {
        const _explicitProp = field.value.componentProps.enableImageUpload;
        // 当 enableImageUpload 被显式设置为 false 时，直接关闭OCR，优先级最高
        if (_explicitProp === false) {
          _enableImageUpload = false;
        } else {
          const _$context = field.value.form?.values?.$context || {};
          let _photoServiceMatch = false;
          let _photoKeyMatch = false;
          try {
            const photoServiceList = JSON.parse(store.getters.getConfigItem('photoServiceList'));
            if (Array.isArray(photoServiceList) && photoServiceList.includes(_$context.service_name)) {
              _photoServiceMatch = true;
            }
          } catch (e) {}
          try {
            const photoKeyList = JSON.parse(store.getters.getConfigItem('photoKeyList'));
            if (Array.isArray(photoKeyList)) {
              if (photoKeyList.length === 0 || photoKeyList.includes(_$context.ProcessDefinitionKey)) {
                _photoKeyMatch = true;
              }
            }
          } catch (e) {}
          let _photoFieldBlocked = false;
          try {
            const photoFieldBlacklist = JSON.parse(store.getters.getConfigItem('photoFieldBlacklist'));
            if (Array.isArray(photoFieldBlacklist) && photoFieldBlacklist.includes(_$context.ProcessDefinitionKey)) {
              _photoFieldBlocked = true;
            }
          } catch (e) {}
          _enableImageUpload = !_photoFieldBlocked && (_explicitProp || _photoServiceMatch || _photoKeyMatch);
        }
      } catch (e) {
        _enableImageUpload = false;
      }

      return h(
      Scanner,
      {
        attrs: { 
          ...curProps, 
          ...attrs, 
          enableImageUpload: _enableImageUpload,
          photoAlbumDisabled: _photoAlbumDisabled,
          processDefinitionKey: field.value.form?.values?.$context?.ProcessDefinitionKey || ''
        },
        on: {
          enter: (val) => {
            console.log(val, "val");
            const data = field.value.componentProps;
            console.log(data, "componentProps");
            if (data.dmLink) {
              const devCString = val;
              const fixedStr = devCString.replace(/'/g, '"');
              const parsedObj = JSON.parse(fixedStr);
              const newDevC = parsedObj.DevC;
              const newDevN = parsedObj.DevN;

              const queryParams = [];

              if (newDevC) queryParams.push(`DevC=${newDevC}`);
              if (newDevN) queryParams.push(`DevN=${newDevN}`);
              if (data.simId) queryParams.push(`simId=${data.simId}`);

              let url = data.href;

              if (queryParams.length > 0) {
                url += '?' + queryParams.join('&');
              }

              console.log(url, '拼接的url');
              window.open(url, '_blank');
            }

            if (field.value.componentProps.debounce) {
              const nowStamp = Number(new Date());
              // const diff = nowStamp - timeStamp.value;

              changeVal(val);
              timeStamp.value = nowStamp;
              // console.log(nowStamp, timeStamp.value, diff);
            } else {
              emit('enter', val);
              emit('change', val);
            }

            // if (field.value.componentProps.debounce && val === field.value.value) return;
          },
          input: (val) => {
            emit('input', val);
          },
        },
      },
      {
        default: () => [curProps.value || attrs.content],
      },
    );
    };
  },
}));

const ScannerCpn = connect(
  formilyScanner,
  mapProps({
    value: 'modelValue',
    readOnly: 'readonly',
  }),
  mapReadPretty(PreviewText.Input),
);

export default ScannerCpn;
